<template>
  <div><!-- 
    <Header /> -->
      <v-row>
          <v-col v-for="pricinglists in get_plan_list" :key="pricinglists.id">
            <v-card
              class="mx-auto"
              max-width="340"
            >
              <v-card-text :class="pricinglists['name'] == 'Gold'? 'active' : ''">
                <span class="popular-plan" v-if="pricinglists['name'] == 'Gold'">MOST POPULAR PLAN</span>
                <div class="plan-detailbox">
                    <h3>{{pricinglists['name']}}</h3>
                    <p>{{pricinglists['description']}}</p>
                    <h2><span>&#8377</span> {{pricinglists['amount']}}/<span class="light-weight">mo</span></h2>
                    <ul>
                      <li v-for="json_decoded_notes in pricinglists['json_decoded_notes']">{{json_decoded_notes['note']}}</li>
                    </ul>
                    <div class="choose-box">
                        <p>Read & Accept <a @click="openTermOfServices">Terms & Conditions</a></p>
                        <button id="rzp-button1" class="btn choose-btn" @click="choosePlan(pricinglists['amount'],pricinglists['id'],pricinglists['plan_id'],['period'],pricinglists['currency'],pricinglists['name'])">CHOOSE PLAN</button>
                    </div>
                </div>
              </v-card-text>

            </v-card>
          </v-col>
      </v-row>
      <modal name="termsandservices"><span> <button type="button" class="close" 
      @click="close" style="float: right;"> X&nbsp;&nbsp;&nbsp;&nbsp;
      </button></span></br>This is Term & Conditions</modal>
  </div>
</template>
<script>
  import { Auth } from 'aws-amplify';
  import Header from '../common/Header.vue';
  import JwtService from ".././common/jwt.service";
  import { isEmpty } from 'lodash';
  export default {
    components: {Header},
    data: () => ({
      get_plan_list: '',
      isAddClassMainBox:true,
      userName:'',
      email:'',
      amount:'',
      order_id:'',
      customer_id:'',
    }),
    computed: {  
      isDataEmpty: function () {
        return isEmpty(this.$store.getters.getProfileDetail.data);
      },
    },
    mounted (){
      if(!this.isDataEmpty){
        this.appendPlanList();
      }
    },
    unmounted(){
      this.appendPlanList();
    },
    methods: {
      openTermOfServices(){
        this.$modal.show("termsandservices");
      },
      close(){
        this.$modal.hide("termsandservices");
      },
      appendPlanList(){         
        this.get_plan_list = this.$store.getters.getProfileDetail.data.subscription_plans.monthly_plan; 
      },
      choosePlan(amount,id,plan_id,period,currency,pricingListName){
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        JwtService.setAmount(amount);
        JwtService.setPlan(plan_id);
        JwtService.setPrice(id);
        JwtService.setPlan(plan_id);
        JwtService.setPeriod(period);
        JwtService.setCurrency(currency);
        JwtService.setPricingListName(pricingListName);
        JwtService.setMonthly('monthly');

        this.$router.push({ name: "PaymentDetail", params: { amount: amount,id:id,plan_id:plan_id,period:period,currency:currency,pricingListName:pricingListName,monthly:'monthly' } }).catch(()=>{});
      }
    }
  }
</script>